var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModuloDeAsignacion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 89.99 88.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b2b2b2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m74.99,0H15C6.73,0,0,6.73,0,15v44.99c0,8.27,6.73,15,15,15h10.96l14.06,11.84c1.43,1.27,3.23,1.9,5.01,1.9s3.49-.61,4.84-1.81l14.43-11.92h10.69c8.27,0,15-6.73,15-15V15c0-8.27-6.73-15-15-15h0ZM26.25,44.99c-3.1,0-5.62-2.52-5.62-5.62s2.52-5.62,5.62-5.62,5.62,2.52,5.62,5.62-2.52,5.62-5.62,5.62Zm18.75,0c-3.1,0-5.62-2.52-5.62-5.62s2.52-5.62,5.62-5.62,5.62,2.52,5.62,5.62-2.52,5.62-5.62,5.62Zm18.75,0c-3.1,0-5.62-2.52-5.62-5.62s2.52-5.62,5.62-5.62,5.62,2.52,5.62,5.62-2.52,5.62-5.62,5.62Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuloDeAsignacion);
export default __webpack_public_path__ + "static/media/moduloDeAsignacion.0558bdc7868c9efe041f57df99080406.svg";
export { ForwardRef as ReactComponent };